export default __webpack_public_path__ + "static/media/zynaxLTD demo project.2ea81fb0.webp";